export default "__VITE_ASSET__2gD7X_8u__"